module.exports = __webpack_public_path__ + "static/step-1-25bd8748be62ed33431d4926af9feadb.png";